import React, { useState, useEffect, useRef } from "react";
import Select from 'react-select';
import axios from 'util/axios';


const SelectMultiV2 = ({
    api,
    body,
    onChange,
    value,
    name = "",
    options=[],
    search = false,
    textAlign = "left",
    arrow = false,
    isTable = false,
    placeholder = "Search...",
    isDisabled = false,
}) => {
    const customStyle = {
        option: (provided, state) => ({
            ...provided,
            textAlign: textAlign,
            width: "max-content",
            color: state.isDisabled ? "#CCC" : "#000",
            backgroundColor: state.isFocused ? "#EEEEFF" : "#FFF",
        }),
        singleValue: (provided, state) => ({
            ...provided,
            color: "#555",
            textAlign: textAlign,
            fontSize: isTable ? "10px" : "inherit",
        }),
        control: (provided, state) => ({
            ...provided,
            backgroundColor: "transparent",
            boxShadow: "none",
            minHeight: "initial",
            border: "none",
        }),
        menu: (provided, state) => ({
            ...provided,
            width: "max-content",
            minWidth: "100%",
            zIndex: 20,
        }),
        valueContainer: (provided, state) => ({
            ...provided,
            padding: "none",
            height: "28px"
        }),
        input: (provided, state) => ({
            ...provided,
            padding: 0,
            margin:  0
        }),
        placeholder: (provided, state) => ({
            ...provided,
            textAlign: "left",
            paddingRight: "5px",
            color: state.isDisabled ? "transparent" : "#CCC"
        }),
        dropdownIndicator: (provided, state) => ({
            ...provided,
            display: "none"
        }),
        indicatorSeparator: (provided, state) => ({
            ...provided,
            display: "none"
        }),
        multiValue: (provided, state) => ({
            ...provided,
            margin: "0px 2px 0 2px"
        }),
        multiValueLabel: (provided, state) => ({
            ...provided,
            fontSize: "0.7rem",
            // padding: null
        }),
        clearIndicator: (provided, state) => ({
            ...provided,
            padding: 0
        }),
    }

    // const [_value, _setValue] = useState(null)

    // const saved = useRef([]);

    // const apiCall = async () => {
    //     const response = await axios.post(api, body).then(Response => Response.data.data.result);
    //     return response;
    // }

    // const filterOption = async (inputValue) => {
    //     const options = await apiCall();
    //     saved.current = options;
    //     const search = options.filter(i => {
    //         if(i.label.toLowerCase().includes(inputValue.toLowerCase()) ||  i.value.toLowerCase().includes(inputValue.toLowerCase())) return true
    //         })
    //     return search;
    // }

    // const loadOptions = async (inputValue, callback = () => [{label: "A", value: "A"}]) => {
    //      callback(await filterOption(inputValue));
    // }

    // useEffect(() => {
    //     if(!!value && value.length>0) {
    //         setVal();
    //     } else {
    //         _setValue(null)
    //     }
    // },[value])
    // const setVal = async() => {
    //     const find = options?.filter(i => 
    //         value.find(e => e === i.value.toLowerCase())
    //     )
    //     _setValue(find);
    // }

    return <Select
        className={"searchable-dropdown"}
        classNamePrefix={"searchable-dropdown"}
        styles={customStyle}
        name={name}
        isMulti={true}
        value={value}
        onChange={onChange}
        options={options}
        placeholder={placeholder}
        // defaultOption={defaultOption}
    />
}

export default SelectMultiV2